module.exports = __webpack_public_path__ + "img/icon_sec3_4@2x.1d599121.png";